import React from 'react'
// react component for creating dynamic tables
import ReactTable from 'react-table'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
import DeleteForever from '@material-ui/icons/DeleteForever'
import WhereToVote from '@material-ui/icons/WhereToVote'
import ZoomIn from '@material-ui/icons/ZoomIn'
// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
// import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import LinearProgress from '@material-ui/core/LinearProgress'

// general api service
import { deleteRecord, finishPaymentForApplication, retrieveDataUsingGraphQL } from '../../services/generalServiceAPI'
import { titleCase,  logger,  reactTableFilterCaseInsensitive,  ymd } from '../utility/utility'
import appContext from '../../services/context'
import remove from 'lodash/remove'
import isEmpty from 'lodash/isEmpty'
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx'
import swal from 'sweetalert'
// import { debounce, throttle } from 'lodash'

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  // .ReactTable:{
  //   width: "100vw",
  //   height: "100vh"
  // },
  pbarRoot: {
    height: '20px',
  },
  progress: {
    margin: '0px',
    width: '100%',
  },
  linearBarColorPrimary: {
    backgroundColor: '#dadada',
  },
  inProress: {
    backgroundColor: '#999999', //'#ddbf00'
  },
  completed: {
    backgroundColor: '#40ab0c',
  },
  rejected: {
    backgroundColor: '#f00',
  },
}
const displayAmount = (applicationTypeId, amount, currency, total) => {
  // console.log({ applicationTypeId, amount, currency, total })
  switch (applicationTypeId) {
    case 0:
      return amount ? `${amount.toMoney()}(${currency})` : ''
    case 1:
      return ''
    case 2:
      return total
    default:
      return 'error'
  }
}
const applicationBrief = ({
  type,
  expenseType,
  expenseOrProcurement,
  creator,
  createdOn,
  activeStep,
  lastLevelToSign,
  status,
  signers,
  amount,
  total,
  currency,
  reason,
  description,
  archived,
  ...others
}) => {
  const getInfo = () => {
    const temp = type.id === 0 ? (isEmpty(description) ? '' : description + ' ') : isEmpty(reason) ? '' : reason + ' '
    const s = temp.substr(0, temp.length > 50 ? 50 : temp.length)
    return <div onClick={() => swal(temp)}>{s.length >= 50 ? s + ' ...' : s}</div>
  }
  try {
    // if (isEmpty(signers[lastLevelToSign - 1])) console.log({ status, signers, lastLevelToSign })
    return {
      ...others,
      status,
      short: type.short,
      type: type.id === 0 ? `${expenseOrProcurement.substr(0, 3)} - ${expenseType.name}` : 'N/A',
      // displayAmount: type.id === 0 ? (amount ? `${amount.toMoney()}(${currency})` : '') : type.id === 2 ? total : '',
      displayAmount: displayAmount(type.id, amount, currency, total),
      creator: titleCase(creator.name),
      createdOn: createdOn.substr(0, 10),
      progress: ((activeStep + (status === 'rejected' ? 1 : 0)) / lastLevelToSign) * 100,
      signedDate: ymd(status === 'completed' ? (isEmpty(signers[lastLevelToSign - 1]) ? 'error' : signers[lastLevelToSign - 1].signedOn) : createdOn),
      isArchived: !isEmpty(archived.user),
      info: getInfo(),
    }
  } catch (error) {
    // somehow a GAT is saved without expenseType, it will error out and result in no application is displayed
    // console.log(error)
    logger('[ApplicationTable][applicationBrief]: ', error, true)
  }
}
class ApplicationTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
      // when this is true, the table will wait for rendering
      loading: true,
      filtered: [],
      sorted: [],
      pageNumber: 0,
      pageSize: 10,
    }
    this.pullingData = this.pullingData.bind(this)
  }
  static contextType = appContext
  pullingData(args) {
    let query
    let variables
    // get basic info of application
    query = `
      query Applications($userId: ID!,$companyId: ID!, $role: Int, $status: String, $scope: String, $textSearch: String,$pageNumber: Int, $pageSize: Int, $filtered: String, $sorted: String){
          applications(userId: $userId,companyId:$companyId, role:$role, status: $status, scope: $scope, textSearch: $textSearch,pageNumber:$pageNumber, pageSize:$pageSize, filtered:$filtered, sorted: $sorted) {
            pages
            applications {
              id
              description
              reason
              type {
                id
                short
              }
              expenseType{
                name
              }
              expenseOrProcurement
              payTo
              amount
              currency
              startDate
              endDate
              creatorId
              creator{
                id
                name
              }
              createdOn
              activeStep
              lastLevelToSign
              lastModifiedOn
              status
              signers {
                signedOn
              }
              archived {
                user {
                  firstname
                  lastname
                }
                on
              }
              total
            }
          }
      }
    `
    const { pageNumber, pageSize, filtered, sorted } = { ...this.state, ...args }
    logger('[ApplicationTable][pullingData][1]:', { ...this.props, pageNumber, pageSize, filtered, sorted, ...args }, true)
    /*
      1) when clicking on menu to route: props->history->location->(pathname, state)
      2) when pushing history to route:  props->location->blah
    */
    const { status, scope, applications, location } = this.props

    if (typeof applications === 'undefined') {
      variables = {
        userId: this.context.user ? this.context.user.id : '',
        companyId: this.context.user.companyId,
        role: this.context.user.roleID,
        status,
        scope,
        textSearch: location ? location.textSearch : '',
        pageNumber,
        pageSize,
        filtered: JSON.stringify(filtered),
        sorted: JSON.stringify(sorted),
      }
      this.setState({ loading: true })
      retrieveDataUsingGraphQL(query, variables)
        .then((response) => {
          if (response.ok) {
            // console.log(response)
            return response.json()
          } else {
            logger('[ApplicationTable][pullingData][2]: ', response, true)
            response.text().then((error) => swal('Error', error, 'error'))
            // throw new Error('Something wrong ' + JSON.stringify(variables))
          }
        })
        .then(({ data }) => {
          logger('[ApplicationTable][pullingData][3]: ', data, true)
          const { pages, applications } = data.applications
          this.setState({
            data: {
              ...this.state.data,
              // creator 不存在的时候会出问题， 因为不存在可以定是错误， 99% from testing, so just 过滤掉
              applications: applications.filter((a) => !isEmpty(a.creator)).map((a) => applicationBrief(a)),
            },
            pages,
            loading: false,
          })
        })
        .catch((e) => {
          logger('[ApplicationTable][pullingData][4]: ', e.message, true)
          this.setState({
            loading: false,
          })
        })
    } else {
      this.setState({
        loading: false,
      })
    }
  }

  componentDidUpdate() {
    // console.log(this.props.location.textSearch)
    if (this.props.location && this.props.location.textSearch) this.pullingData()
  }
  async componentDidMount() {
    const filter = localStorage.getItem('applicationFilter')
    await this.setState(JSON.parse(filter))
    this.pullingData()

  }
  componentWillUnmount() {
    const { filtered } = this.state
    localStorage.setItem('applicationFilter', JSON.stringify({ filtered }))
  }
  onRowClick = (state, rowInfo, instance) => {
    return rowInfo
      ? {
          style: {
            background: rowInfo.index % 2 === 0 ? '#e0e0e0' : '#ffffff',
            color: 'black',
            height: '40px',
            margin: '2px',
          },
        }
      : {}
  }
  //getTdProps={this.onRowClick}
  render() {
    // 如果有上层传入application data,就用他们显示， 否则上层应该传入参数，用此component自己从数据库查询获取数据
    const { classes, history, applications } = this.props
    let data = typeof applications === 'undefined' ? this.state.data.applications : applications.filter((a) => !isEmpty(a)).map((a) => applicationBrief(a))

    // display header of table
    if (isEmpty(data)) {
      data = [{}]
    }
    return (
      <GridContainer>
        {/* {this.state.pageSize} */}
        <Card>
          <CardBody>
            <ReactTable
              data={data}
              defaultFilterMethod={(filter, row) => reactTableFilterCaseInsensitive(filter, row)}
              loading={this.state.loading}
              filterable
              filtered={this.state.filtered}
              // pagination starts
              onFilteredChange={(filtered) => {
                const filterChangedTimer = setTimeout(this.pullingData, 1000)
                clearTimeout(this.state.filterChangedTimer)
                this.setState({ filtered, filterChangedTimer })
              }}
              onSortedChange={(sorted) => {
                this.setState({ sorted })
                this.pullingData({ sorted })
              }}
              manual
              pages={this.state.pages}
              page={this.state.pageNumber}
              onPageChange={(pageNumber) => {
                this.setState({ pageNumber })
                this.pullingData({ pageNumber })
              }}
              onPageSizeChange={(pageSize) => {
                this.setState({ pageSize })
                this.pullingData({ pageSize })
              }}
              // pagination ends
              // getTrProps={reactTableRowCustomization}
              //onResizedChange={(newResized, event) => {console.log('resize', newResized, event)}}
              columns={[
                {
                  Header: () => <div style={{ textAlign: 'left' }}></div>,
                  id: 'actions',
                  maxWidth: 100,
                  sortable: false,
                  filterable: false,
                  accessor: (d) => {
                    return isEmpty(d.status) ? (
                      ''
                    ) : (
                      <div>
                        <Button
                          justIcon
                          // size='lg'
                          round
                          simple
                          onClick={(e) => {
                            history.push(`/application/${d.short.toLowerCase()}/${d.id}`)
                          }}
                          color='primary'
                          style={{ padding: '0px', margin: '0px' }}
                        >
                          <ZoomIn className={classes.icon} />
                        </Button>
                        {(d.status === 'draft' && d.creatorId === this.context.user.id) ||
                        (d.status === 'submitted' && d.creatorId === this.context.user.id && d.progress === 0) ||
                        this.context.user.id === 'zd794w' ||
                        this.context.user.roleID === 0 ? (
                          <Button
                            id={'remove'}
                            name={'remove'}
                            round
                            simple
                            onClick={async (e) => {
                              await deleteRecord({
                                id: d.id,
                                tableName: 'applications',
                                refetch: () => {
                                  const { applications } = this.state.data

                                  this.setState({
                                    applications: remove(applications, (a) => a.id === d.id),
                                  })
                                },
                              })
                            }}
                            justIcon
                            // size='lg'
                            color='primary'
                            style={{ padding: '0px' }}
                          >
                            <DeleteForever className={classes.icon} />
                          </Button>
                        ) : (
                          ''
                        )}
                        {this.context.user.id === 98 ||
                        this.props.history.location.pathname === '/applications/finished' ||
                        this.context.user.id === 'zd794w' ? (
                          <Button
                            id={'received'}
                            name={'received'}
                            round
                            simple
                            onClick={async (e) => {
                              await finishPaymentForApplication({
                                id: d.id,
                                tableName: 'applications',
                                archived: {
                                  by: this.context.user.id,
                                  on: new Date(),
                                },
                                refetch: () => {
                                  const { applications } = this.state.data

                                  this.setState({
                                    applications: remove(applications, (a) => a.id === d.id),
                                  })
                                },
                              })
                            }}
                            justIcon
                            // size='lg'
                            color='primary'
                            style={{ padding: '0px' }}
                          >
                            <WhereToVote className={classes.icon} />
                          </Button>
                        ) : (
                          ''
                        )}
                      </div>
                    )
                  },
                },
                {
                  Header: 'ID',
                  id: 'id',
                  accessor: ({ id }) => (id ? id.substr(id.length - 4).toUpperCase() : ''),
                  width: 48,
                  sortable: false,
                },
                {
                  Header: 'E/P',
                  id: 'expenseOrProcurement',
                  accessor: 'short',
                  width: 58,
                },
                {
                  Header: 'Type',
                  minWidth: 200,
                  accessor: 'type',
                  Cell: ({ row }) => (
                    <div>
                      <span title={row._original.description}>{row.type}</span>
                    </div>
                  ),
                },
                {
                  Header: 'Vendor',
                  id: 'payTo',
                  accessor: 'payTo',
                  minWidth: 150,
                },
                {
                  Header: 'Amount',
                  id: 'amount',
                  accessor: 'displayAmount',
                  // accessor: ({ amount, currency }) => (amount ? `${amount.toMoney()}(${currency})` : ''),
                  width: 130,
                },
                {
                  Header: 'Requestor',
                  id: 'creator',
                  accessor: 'creator',
                  width: 104,
                },
                {
                  Header: () => (this.props.history.location.pathname === '/applications/finished' ? 'Cmpl On' : 'Rqst On'),
                  // Header: 'On',
                  // accessor: ({ signedDate, createdOn }) => (this.props.history.location.pathname === '/applications/finished' ? signedDate : createdOn),
                  // signedDate 在没有完成时候就是created date
                  id: 'signedOrRequestedDate',
                  accessor: 'signedDate',
                  width: 100,
                  sortable: false,
                  filterable: false,
                },
                {
                  Header: 'Description',
                  id: 'description',
                  accessor: 'info',
                  minWidth: 120,
                  maxWidth: 550,
                  // sortable: false,
                  filterable: true,
                },
                {
                  Header: 'A',
                  id: 'isArchived',
                  accessor: 'isArchived',
                  Cell: ({ row }) => (row.isArchived ? <span style={{ backgroundColor: 'blue' }}>' '</span> : ''),
                  maxWidth: 30,
                  // sortable: false,
                  filterable: false,
                  sortable: false,
                },
                // 进度条
                {
                  Header: 'Progress',
                  id: 'progress',
                  sortable: false,
                  filterable: false,
                  accessor: 'progress',
                  maxWidth: 90,
                  Cell: ({ row }) => {
                    //logger('[ApplicationTable][render][1]: ', { row })
                    return !isEmpty(row._original) && row._original.status !== 'draft' ? (
                      <LinearProgress
                        classes={{
                          // [classes.progress]: true,
                          root: classes.pbarRoot,
                          colorPrimary: classes.inProress,
                          barColorPrimary: row._original.status !== 'rejected' ? classes.completed : classes.rejected,
                        }}
                        variant='determinate'
                        value={isEmpty(row._original) ? -1 : row._original.progress}
                      />
                    ) : (
                      ''
                    )
                  },
                },
              ]}
              defaultPageSize={10}
              showPaginationTop={false}
              showPaginationBottom //={true} //can be ignored
              showPageJump
              pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
              className='-striped -highlight table'
            />
          </CardBody>
        </Card>

        {/* {(this.state.loading, this.state.filtered, this.state.sorted, this.state.pageNumber, this.state.pageSize)} */}
        {/* {jsonPP(this.props.applications.length)} */}
        {/* {jsonPP(this.context)} */}
        {/* {jsonPP(this.props)} */}
      </GridContainer>
    )
  }
}

export default withStyles(styles)(ApplicationTable)
